import { ILISKILI_BASVURU_GECMISI_GETIR } from "../constants/requestUrls";
import { getRequest } from "../request";

const iliskiliBasvuruGecmisSorgula = (parentObjectId) => {
    return getRequest({ url: ILISKILI_BASVURU_GECMISI_GETIR + "?parentObjectId=" + parentObjectId });
}

export default iliskiliBasvuruGecmisSorgula;